import React, { createContext, useContext, useState } from "react";

const AppConfigContext = createContext(null);

export const AppConfigProvider = ({ children }) => {
  const [isLcoId, setIsLcoId] = useState(false);

  return (
    <AppConfigContext.Provider value={{ isLcoId, setIsLcoId }}>
      {children}
    </AppConfigContext.Provider>
  );
};

export const useAppConfig = () => useContext(AppConfigContext);